import applelogo from '../../assets/applelogo.png';
import googleplay from '../../assets/googleplay.png';

// Links reais das lojas. Pra trocar, mude os IDs aqui.
const APP_STORE_URL = 'https://apps.apple.com/br/app/uen-estudantil/id6778991009';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.uen.uenestudantil';

// Estilo base compartilhado pelos dois botões (cartão branco com logo + texto).
const btnBase = {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '12px',
    background: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: '14px',
    padding: '10px 16px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.10)',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    boxSizing: 'border-box',
};

const logoStyle = {
    width: '26px',
    height: '26px',
    objectFit: 'contain',
    display: 'block',
    flexShrink: 0,
};

const textWrap = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    lineHeight: 1.15,
    minWidth: 0,
};

const topLabel = {
    fontSize: '10px',
    fontWeight: 500,
    color: '#6B7280',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
};

const storeName = {
    fontSize: '17px',
    fontWeight: 700,
    color: '#1F2937',
    marginTop: '1px',
};

const onEnter = (e) => {
    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.16)';
    e.currentTarget.style.transform = 'translateY(-2px)';
};
const onLeave = (e) => {
    e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.10)';
    e.currentTarget.style.transform = 'translateY(0)';
};

// Botão genérico de loja — garante que App Store e Google Play fiquem idênticos.
function StoreButton({ logo, alt, top, name, url, ariaLabel }) {
    return (
        <button
            onClick={() => url && window.open(url, '_blank')}
            style={btnBase}
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
            aria-label={ariaLabel}
        >
            <img src={logo} alt={alt} style={logoStyle} />
            <span style={textWrap}>
                <span style={topLabel}>{top}</span>
                <span style={storeName}>{name}</span>
            </span>
        </button>
    );
}

export function AppleStoreButton() {
    return (
        <StoreButton
            logo={applelogo}
            alt="App Store"
            top="Baixar na"
            name="App Store"
            url={APP_STORE_URL}
            ariaLabel="Baixe na App Store"
        />
    );
}

export function GooglePlayButton() {
    return (
        <StoreButton
            logo={googleplay}
            alt="Google Play"
            top="Disponível no"
            name="Google Play"
            url={PLAY_STORE_URL}
            ariaLabel="Disponível no Google Play"
        />
    );
}
